// src/data/faqData.ts

export const solarFaqs = [
  {
    question: 'How do solar panels work?',
    answer: 'Solar panels convert sunlight into electricity using photovoltaic cells.',
  },
  {
    question: 'Can I use solar energy at night?',
    answer: 'Solar panels do not generate power at night, but a battery system or grid connection provides power.',
  },
    {
    question: 'How much can I save with solar panels?',
    answer:
      'Savings depend on your location, energy usage, and system size, but most customers see a significant reduction in their electricity bills.',
  },
  {
    question: 'Do solar panels work on cloudy days?',
    answer:
      'Yes! Solar panels still produce energy on cloudy days, though at a reduced rate compared to sunny days.',
  },
  {
    question: 'What is the installation process like?',
    answer:
      'We start with a consultation and site assessment, design a custom system, Free Quote, handle permitting, equipment, Interconnection  paperwork and approvals to connect your system to the gridand, schedule a professional installation and support.',
  },
];

export const installerFaqs = [
  {
    question: 'What qualifications do your solar installers have?',
    answer: 'All our installers are vetted and certified to meet local, state, and national solar installation standards.',
  },
  {
    question: 'How do you select installer partners?',
    answer: 'We interview, verify licenses, check insurance, and ensure compliance with industry regulations before partnering.',
  },
  {
    question: 'Are installer partners insured?',
    answer: 'Yes, all partners carry general liability insurance and workers’ compensation, verified before onboarding.',
  },
  {
    question: 'What states do your installers operate in?',
    answer: 'Our certified partners operate across multiple states, and we match them based on project location and compliance.',
  },
  {
    question: 'Do you guarantee the installer’s work?',
    answer: 'Yes, we offer workmanship guarantees for all partner installations through quality audits and contractual standards.',
  },
];

export const designFaqs = [
  {
    question: 'What factors are considered in a custom solar design?',
    answer: 'We evaluate your roof angle, shading, energy consumption, and available space to create the most efficient layout.',
  },
  {
    question: 'Do I need a battery with my solar system?',
    answer: 'Not necessarily. Grid-tied systems work without batteries, though storage helps during outages or peak hours.',
  },
  {
    question: 'How long does the design process take?',
    answer: 'Typically 3–5 business days after site assessment and reviewing your utility usage.',
  },
  {
    question: 'Can my solar system be expanded later?',
    answer: 'Yes. We design with future expansion in mind if you plan to add more panels or electric vehicles.',
  },
  {
    question: 'Who signs off on the final system design?',
    answer: 'A NABCEP-certified engineer reviews and approves every system design before permitting.',
  },
  {
    "question": "What is included in your solar system design service?",
    "answer": "Our solar system design service includes a customized solar energy solution tailored to your property. We assess your energy needs, analyze roof space or ground area, design an optimal panel layout, calculate system size, provide equipment recommendations, and generate a performance estimate. The final design includes detailed schematics, shading analysis, and financial projections."
  },
];

export const SolarIncentivesFAQs = [
  {
    question: "What is the Federal Solar Tax Credit (ITC)?",
    answer:
      "The Federal Solar Tax Credit allows you to deduct 30% of the cost of installing a solar energy system from your federal taxes. It's available for both residential and commercial systems installed before 2032.",
  },
  {
    question: "Are there any local or state incentives for solar panels?",
    answer:
      "Yes, many states and municipalities offer additional incentives like rebates, performance-based incentives (PBIs), and property tax exemptions. Check your local government or utility provider for details.",
  },
  {
    question: "Can I combine multiple solar incentives?",
    answer:
      "Absolutely. You can combine the Federal ITC with state and local incentives, as well as net metering programs, to maximize your savings and reduce your system’s payback time.",
  },
  {
    question: "Do solar incentives apply to battery storage systems?",
    answer:
      "Yes, battery systems paired with solar panels are eligible for the Federal Tax Credit if installed at the same time. Some states also offer incentives for standalone battery storage.",
  },
  {
    question: "How do I claim the solar tax credit on my taxes?",
    answer:
      "To claim the Federal Solar Tax Credit, you must file IRS Form 5695 with your tax return. It's recommended to consult a tax professional to ensure proper documentation and compliance.",
  },
];

export const SolarPanelInstallationFAQs = [
  {
    "question": "Do you consider shading and roof orientation in the design?",
    "answer": "Yes! We use advanced solar modeling software (like Aurora, PVsyst, or Helioscope) to analyze shading from trees, buildings, or obstructions. We optimize panel placement based on roof angle, orientation (south-facing is ideal in the Northern Hemisphere), and local weather patterns to maximize energy production."
  },
  {
    question: 'How long does a typical solar panel installation take?',
    answer: 'Most residential installations are completed in 1-3 days, depending on system size and complexity. Commercial projects may take 1-2 weeks. This doesn\'t include permitting and inspections which can add several weeks to the process.'
  },
  {
    question: 'Will my electricity be interrupted during installation?',
    answer: 'We typically coordinate a brief shutdown (2-4 hours) to connect your system safely. We\'ll schedule this at your convenience and provide advance notice. Your power will remain on until the final interconnection is approved by your utility.'
  },
  {
    question: 'What roof preparations are needed before installation?',
    answer: 'We require a structurally sound roof with at least 10-15 years of remaining life. Any necessary repairs should be completed beforehand. Our team will verify roof condition during the site assessment and recommend any needed reinforcements.'
  },
  {
    question: 'Do you handle all the necessary permits and inspections?',
    answer: 'Yes, our team manages the entire permitting process including utility interconnection applications, building permits, and scheduling inspections. We stay current with all local regulations to ensure compliance.'
  }
];